import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { injectIntl } from 'react-intl';
import { bindAll } from '@bibliocommons/utils-react';
import Checkbox from '@bibliocommons/deprecated-base-checkbox';
import { getLabel } from '@bibliocommons/utils-filter';
import '../styles/CheckboxFilter.scss';

class CheckboxFilter extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleToggleFilter(checked, { value: filter }) {
    this.props.handleToggleFilter(this.props.fieldId, filter);
  }

  render() {
    const { fieldId, filter, intl, refFunction, group } = this.props;
    const value = filter.get('value');
    const label = filter.get('label');
    const count = filter.get('count');
    const applied = filter.get('applied');

    const filterLabel = getLabel(intl, fieldId, label || value);
    const formattedLabel = intl.formatMessage({ id: 'Facets.filterLabelFormat' }, { value: filterLabel, count });
    const checkboxId = [fieldId, group, value].filter(v => !!v).join('-');

    return (
      <Checkbox
        id={checkboxId}
        handleChange={this.handleToggleFilter}
        value={filter}
        checked={applied}
        label={formattedLabel}
        labelTestId={`${checkboxId}-filter`}
        ref={refFunction}
        dataKey="checkbox-filter"
      />
    );
  }
}
CheckboxFilter.propTypes = {
  group: PropTypes.string,
  filter: ImmutablePropTypes.map.isRequired,
  fieldId: PropTypes.string.isRequired,
  handleToggleFilter: PropTypes.func.isRequired,

  refFunction: PropTypes.func
};

CheckboxFilter.defaultProps = {
  group: ''
};

export default injectIntl(CheckboxFilter);
